module.exports = __webpack_public_path__ + "static/img/avoid-captcha.252e9e53.jpg";